
import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AccountSuspended = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  // Removed useEffect redirect logic to prevent loops
  
  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login', { replace: true });
  };
  
  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard', { replace: true });
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 p-3 rounded-full">
            <AlertTriangle className="h-12 w-12 text-red-500" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">חשבון מושהה</h1>
        
        <div className="text-gray-600 mb-6">
          <p className="mb-2">החשבון שלך הושהה או אינו פעיל כרגע.</p>
          <p>אם אתה סבור שזו טעות, אנא צור קשר עם מנהל המערכת או התמיכה.</p>
          
          {user && (
            <div className="mt-4 p-3 bg-gray-100 rounded-md text-sm text-left">
              <p><strong>דוא"ל:</strong> {user.email}</p>
              <p><strong>מזהה משתמש:</strong> {user.id}</p>
            </div>
          )}
          
          <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mt-4">
            <p className="text-yellow-700">
              הערה: כרגע כל המשתמשים מקבלים גישה מלאה לצורכי בדיקה.
            </p>
          </div>
        </div>
        
        <div className="flex flex-col space-y-3">
          <Button onClick={handleGoToDashboard} variant="default">
            נסה להיכנס ללוח הבקרה
          </Button>
          <Button onClick={handleLogout} variant="destructive">
            התנתק
          </Button>
          <Button onClick={handleGoHome} variant="outline">
            חזרה לדף הבית
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountSuspended;
